import React from 'react';
import { slideWrapper } from '../components/slide';
import { SlideImage } from '../components/slide-image';
import { Content } from '../components/content';
import { PuzzleItem, PuzzleItemsWrapper } from '../components/puzzle-item';
import { Timer } from '../components/timer';
import { useConfirmation } from '../../generic/hooks/use-confirmation';

export const TeslaPuzzle4 = slideWrapper(({ step, data, getImg, ...props }) => {
  const { answers } = step;

  const ConfirmationPopup = useConfirmation(1);
  return (
    <>
      <ConfirmationPopup />
      <Timer data={data} presentation />
      <Content left={-2} top={20} xNotCenter yNotCenter>
        <SlideImage width="300px" src={getImg('polowaziomka')} show={true} />
      </Content>
      <Content left={20} top={20} yNotCenter>
        <SlideImage width="150px" rotate={'10deg'} src={getImg('szklanka')} show={true} />
      </Content>
      <PuzzleItemsWrapper>
        <PuzzleItem getImg={getImg} letter="a" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="b" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="c" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="d" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="e" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="f" answers={answers} smallItem />
      </PuzzleItemsWrapper>
    </>
  );
});
